export const GENERATE_UNIQUE_ID = "api/questionnaire/v1/helper/generate-unique-id";
// export const DRAFT_SHORTCUT_HASH_INFO = "api/questionnaire/v1/helper/draft-shortcut-hash-info";
export const HELPER_FILE = "/api/questionnaire/v1/helper/file";
export const CHECK_PAYFORM_EXISTS = "/api/questionnaire/v1/helper/check-payform-exists";
export const GET_BANK_INFO = "/api/questionnaire/v1/helper/get-bank-info";
export const DRAFT_PREVIEW = "/api/questionnaire/v1/draft-preview";
export const METRIC_PROGRAMS_ACCEPT = "/api/questionnaire/v1/metric-programs/accept";
export const DRAFT_COMPANY_DETAILS = "/api/questionnaire/v1/draft/company-details";
export const DRAFT_CONTACT_DETAILS = "/api/questionnaire/v1/draft/contact-details";
export const DRAFT_PAYFORM_DETAILS = "/api/questionnaire/v1/draft/payform-details";
export const DRAFT_ACCOUNT_DETAILS = "/api/questionnaire/v1/draft/account-details";
export const DRAFT_PAYFORM_TECH_DETAILS = "/api/questionnaire/v1/draft/payform-tech-details";
export const DRAFT_MARKETPLACE_DETAILS = "/api/questionnaire/v1/draft/marketplace-details";
export const DRAFT_ATTACHMENTS_DETAILS = "/api/questionnaire/v1/draft/attachments-details";
export const DRAFT_ADDITIONAL_DETAILS = "/api/questionnaire/v1/draft/additional-details";
export const DRAFT_SAVE = "/api/questionnaire/v1/questionnaire/save";
export const REPORT_ERROR = "/api/questionnaire/v1/questionnaire/report-error";
export const REQUEST_CODE = "/api/questionnaire/v1/confirmation/request-code";
export const CONFIRM_CODE = "/api/questionnaire/v1/confirmation/confirm-code";
export const CHANGE_PHONE = "/api/questionnaire/v1/draft-edit/phone-change";
export const PERSONAL_DATA_ADDRESS_SUGGEST = "/api/questionnaire/v1/personal-data/address/suggest";